module.exports = __webpack_public_path__ + "static/img/home_part3@2x.69e4185.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_part3@2x.jpg
// module id = 774G
// module chunks = 0